const ScrollToContentTop = ref => {

    ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    
}

export default ScrollToContentTop;